import React, { useState, useEffect } from "react";
import Header from "../layout/Header";
import Sidebar from "../layout/Sidebar";
import { Spin } from "antd";
import Bridge from "../constants/Bridge";
import $ from "jquery";

const OtherDataSources = () => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);

  // on load component function
  useEffect(() => {
    if ($(window).width() < 600) {
      $("#sidebar").removeClass("show-sidebar").addClass("hide-sidebar");
    } else {
      $("#sidebar").removeClass("hide-sidebar").addClass("show-sidebar");
    }
    Bridge.audit_logs.view_consortia_workspace();
    get_list();
  }, []);

  const get_list = () => {
    setLoading(true);
    Bridge.get_consortia_workspace_list().then((result) => {
      console.log("result", result);
      if (result.status == 1) {
        setList(result.data);
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  return (
    <div className="other-data-sources-page">
      <div>
        <Header />
        <div className="row">
          <Sidebar />
          <div
            className="col-lg-10 main_content_right_side"
            style={{
              minHeight: "100vh",
              paddingLeft: "32px",
              paddingRight: "30px",
              marginLeft: "auto",
              backgroundColor: "#F5F5F5",
            }}
          >
            <Spin spinning={loading}>
              <div
                className="main-section dashboard"
                style={{ marginTop: 105 }}
              >
                <div>
                  <p
                    style={{
                      position: "relative",
                      fontSize: 32,
                      fontFamily: "Open Sans",
                      fontWeight: "bold",
                      color: "#1A4F83",
                      textAlign: "start",
                    }}
                    className="mb-4 mt-4"
                  >
                    Data Sources
                  </p>
                  
                  <div style={{ 
                    backgroundColor: "#ffffff", 
                    padding: "25px", 
                    borderRadius: "8px", 
                    marginBottom: "30px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                  }}>
                    <p style={{ 
                      fontSize: 16, 
                      color: "#333", 
                      fontFamily: "Open Sans",
                      lineHeight: "1.7",
                      textAlign: "justify",
                      margin: 0
                    }}>
                      Answer ALS was established to bridge critical knowledge gaps in ALS research by creating a detailed clinical and biological profile of the disease from data collected from over 1,000 participants and 200 healthy controls. The program collects longitudinal clinical data and generates multi-omics datasets, including whole-genome sequencing, transcriptomics, epigenomics, and proteomics, from induced pluripotent stem cell (iPSC)-derived motor neurons. These data are linked to associated biospecimens (patient-derived biofluids and iPSC lines) and made openly available to the global research community through the Answer ALS Neuromine Data Portal. Researchers can link through the Neuromine portal to the Cedars-Sinai Biomanufacturing Center or access their catalog directly at <a href="https://csbiomfg.com/cellcollection/" target="_blank" style={{ color: "#1A4F83", textDecoration: "underline" }}>https://csbiomfg.com/cellcollection/</a>.
                      <br/>
                      <button
                            onClick={() => window.open('https://dataportal.answerals.org/home', '_blank')}
                            style={{
                              backgroundColor: "#1A4F83",
                              color: "white",
                              border: "none",
                              padding: "8px 16px",
                              borderRadius: "4px",
                              fontSize: 12,
                              fontFamily: "Open Sans",
                              cursor: "pointer",
                              fontWeight: "500",
                              marginTop: "30px"
                            }}
                          >
                            Open Data Portal
                          </button>
                    </p>
                    <br/>
                  </div>

                  {/* <div style={{ marginBottom: "30px" }}>
                    <img
                      src="../../assets/img/dev.png"
                      alt="Cell Collection - CSBIO"
                      style={{ 
                        width: "100%", 
                        borderRadius: "8px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                      }}
                    />
                  </div> */}

                  {/* Cell Collection - CSBIO Section */}
                  {/* <div style={{ 
                    backgroundColor: "#ffffff", 
                    padding: "20px", 
                    borderRadius: "8px", 
                    marginBottom: "30px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    height: "200px",
                    overflow: "hidden",
                    width: "60%"
                  }}>
                    <div style={{ display: "flex", alignItems: "flex-start", gap: "20px", height: "100%" }}>
                      <div style={{ width: "30%", height: "100%" }}>
                        <img
                          src="./assets/img/Phase-Image-iPSC1.png.webp"
                          alt="Cell Collection iPSC Lines"
                          style={{ 
                            width: "100%", 
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "8px"
                          }}
                        />
                      </div>
                      <div style={{ width: "70%", height: "100%", display: "flex", flexDirection: "column" }}>
                        <h3 style={{ 
                          fontSize: 18, 
                          fontFamily: "Open Sans",
                          fontWeight: "bold",
                          color: "#1A4F83",
                          marginBottom: "10px",
                          marginTop: 0,
                          textAlign:"left"
                        }}>
                          Cell Collection - CSBIO
                        </h3>
                        <p style={{ 
                          fontSize: 13, 
                          color: "#666", 
                          fontFamily: "Open Sans",
                          lineHeight: "1.5",
                          margin: 0,
                          flex: 1,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign:"left"
                        }}>
                          Cell Collection iPSC Lines GMP IPSC Lines Gene Edited Cell Lines Neural Cells Endothelial Cells ES Cells Induced Pluripotent Stem Cell (iPSC) Lines With over 500 unique iPSC lines spanning over 30 degenerative diseases, our bank of iPSC lines is available for most research purposes. Answer ALS Collection Lothian Birth Cohort NIH HD Consortium SMA [...]
                        </p>
                        <div style={{ marginTop: "10px", display: "flex", gap: "15px", alignItems: "center" }}>
                          <a 
                            href="https://csbiomfg.com" 
                            target="_blank" 
                            style={{ 
                              color: "#1A4F83", 
                              textDecoration: "underline",
                              fontSize: 13,
                              fontFamily: "Open Sans"
                            }}
                          >
                            csbiomfg.com
                          </a>
                         
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </Spin>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherDataSources;
